import React, { useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";

const Application = () => {
    const [user, setUser] = useState({
        name: "John Doe",
        phone: "9876543210",
        email: "john@example.com",
        password: "123456",
        image: "",
    });

    const [editData, setEditData] = useState(user);
    const [showPassword, setShowPassword] = useState(false);

    const handleEditChange = (e) => {
        const { name, value, files } = e.target;
        setEditData((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setUser(editData);
        console.log("Updated Profile:", editData);
    };

    return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Nav />
                    <div className="layout-page">
                        <Header />
                        <div className="content-wrapper">
                            <div className="container py-5">
                                <div
                                    className="card p-4 shadow rounded-4 text-center"
                                    style={{ maxWidth: "400px", width: "100%" }}
                                >
                                    <img
                                        src={
                                            user.image
                                                ? URL.createObjectURL(user.image)
                                                : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsynwv-5qtogtOwJbIjaPFJUmHpzhxgqIAug&s"
                                        }
                                        alt="Profile"
                                        className="rounded-circle mx-auto border mb-3"
                                        width="100"
                                        height="100"
                                    />
                                    <h4 className="text-primary fw-bold">{user.name}</h4>
                                    <p className="mb-1">
                                        <strong>Email:</strong> {user.email}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Mobile:</strong> {user.phone}
                                    </p>
                                    <p className="mb-3">
                                        <strong>Password:</strong>{" "}
                                        {showPassword ? user.password : "********"}
                                        <button
                                            className="btn  ms-2"
                                            onMouseDown={() => setShowPassword(true)}
                                            onMouseUp={() => setShowPassword(false)}
                                            onMouseLeave={() => setShowPassword(false)}
                                        >
                                            👁
                                        </button>
                                    </p>
                                    <div className="text-center">
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#editProfileModal"
                                        >
                                            <i className="bi bi-pencil-square text-primary mx-1"></i>
                                        </button>
                                    </div>
                                </div>

                                {/* Edit Profile Modal */}
                                <div className="modal fade" id="editProfileModal" tabIndex={-1}>
                                    <div className="modal-dialog">
                                        <form className="modal-content" onSubmit={handleSubmit}>
                                            <div className="modal-header">
                                                <h5 className="modal-title">Edit Profile</h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    data-bs-dismiss="modal"
                                                ></button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="mb-3">
                                                    <label className="form-label fw-bold">
                                                        User Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control input-uppercase"
                                                        name="name"
                                                        value={editData.name}
                                                        onChange={handleEditChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label fw-bold">Mobile</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="phone"
                                                        value={editData.phone}
                                                        maxLength={10}
                                                        onChange={handleEditChange}
                                                        required
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label fw-bold">Email</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        value={editData.email}
                                                        onChange={handleEditChange}
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label fw-bold">Password</label>
                                                    <input
                                                        type="password"
                                                        className="form-control"
                                                        name="password"
                                                        placeholder="New Password"
                                                        onChange={handleEditChange}
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label fw-bold">
                                                        Profile Image
                                                    </label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="image"
                                                        accept="image/*"
                                                        onChange={handleEditChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button
                                                    className="btn btn-secondary"
                                                    data-bs-dismiss="modal"
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success px-4"
                                                    data-bs-dismiss="modal"
                                                >
                                                    Save Changes
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Application;
